export const resources = {
  en: {
    common: require('./en/common.json'),
    analytics: require('./en/analytics.json'),
    analyticsReports: require('./en/analyticsReports.json'),
    arMarkers: require('./en/arMarkers.json'),
    authentication: require('./en/authentication.json'),
    configuration: require('./en/configuration.json'),
    experiences: require('./en/experiences.json'),
    htmlTemplates: require('./en/htmlTemplates.json'),
    mediaFiles: require('./en/mediaFiles.json'),
    multilanguageExperiences: require('./en/multilanguageExperiences.json'),
    operators: require('./en/operators.json'),
    productionDashboard: require('./en/productionDashboard.json'),
    qrCodes: require('./en/qrCodes.json'),
    readerRequests: require('./en/readerRequests.json'),
    readers: require('./en/readers.json'),
    stickers: require('./en/stickers.json'),
    tags: require('./en/tags.json'),
    tobaccoProducts: require('./en/tobaccoProducts.json'),
    users: require('./en/users.json')
  }
};
